(() => {
  const SELECTORS = {
    stickyBar: ".Product__StickyBar",
    stickyBarLink: ".Product__StickyBarLink",
  };
  const ACTIVE_CLASS = "is-active";
  const MOBILE_BREAKPOINT = 768;
  const MANUAL_CLICK_RESET_DELAY = 500;
  const SCROLL_DELAY = 100;

  const stickyBar = document.querySelector(SELECTORS.stickyBar);
  const stickyBarLinks = Array.from(
    document.querySelectorAll(SELECTORS.stickyBarLink),
  );

  if (!stickyBar || stickyBarLinks.length === 0) return;

  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  const linksBySection = new Map();
  const sectionSelectors = stickyBarLinks.map((link) => {
    const sectionSelector = link.getAttribute("data-section-id");

    if (!linksBySection.has(sectionSelector)) {
      linksBySection.set(sectionSelector, link);
    }

    return sectionSelector;
  });
  const sections = document.querySelectorAll(sectionSelectors.join(","));
  let manuallyClicked = false;

  const setActiveLink = (activeLink) => {
    stickyBarLinks.forEach((link) =>
      link.classList.toggle(ACTIVE_CLASS, link === activeLink),
    );
  };

  const keepActiveLinkInView = (activeLink) => {
    const linkRect = activeLink.getBoundingClientRect();
    const scrollPadding = isMobile ? 20 : 50;

    if (
      linkRect.left + linkRect.width > window.innerWidth &&
      linkRect.left > 0
    ) {
      stickyBar.scrollTo({
        left:
          linkRect.left +
          linkRect.width -
          window.innerWidth +
          stickyBar.scrollLeft +
          scrollPadding,
      });
    } else if (linkRect.left < 0) {
      stickyBar.scrollTo({
        left: stickyBar.scrollLeft - Math.abs(linkRect.left) - scrollPadding,
      });
    }
  };

  stickyBarLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      manuallyClicked = true;

      const section = document.querySelector(
        link.getAttribute("data-section-id"),
      );

      setTimeout(() => {
        const scrollOffset = isMobile ? 100 : 150;
        const scrollTop =
          section.getBoundingClientRect().top +
          window.scrollY -
          scrollOffset;

        window.scrollTo({ top: scrollTop, behavior: "smooth" });
      }, SCROLL_DELAY);

      setActiveLink(link);

      setTimeout(() => {
        manuallyClicked = false;
      }, MANUAL_CLICK_RESET_DELAY);
    });
  });

  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || manuallyClicked) return;

        const sectionId = entry.target.getAttribute("id");
        const activeLink = linksBySection.get(`#${sectionId}`);

        if (!activeLink) return;

        setActiveLink(activeLink);
        keepActiveLinkInView(activeLink);
      });
    },
    {
      root: null,
      threshold: 0.2,
    },
  );

  sections.forEach((section) => sectionObserver.observe(section));
})();

document.addEventListener("DOMContentLoaded", () => {
  const productBars = document.getElementsByClassName("product-options-bar");
  const firstSection = document.querySelector(".product-main");

  if (!firstSection) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        Array.from(productBars).forEach((productBar) => {
          productBar.classList.toggle("sticky", !entry.isIntersecting);
        });
      });
    },
    {
      root: null,
      threshold: 0,
    },
  );

  observer.observe(firstSection);
});
